// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__3dfUH","name":"styles_name__2dkwy","offer":"styles_offer__2Iic4"};